/* eslint-disable no-shadow */
import { createContext, useState, useEffect, useContext } from 'react'

import { getRole } from './getRole'
import { getIdentityClientInstance } from './solta-id'

import { AuthService } from 'modules/auth'

const DEFAULT_REDIRECT_CALLBACK = () =>
  window.history.replaceState({}, document.title, window.location.pathname)

export const IdentityContext = createContext()
export const useIdentity = () => useContext(IdentityContext)
export const IdentityProvider = ({
  children,
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  domain,
  clientId,
  redirectUrl,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState()
  const [organization, setOrganization] = useState()
  const [user, setUser] = useState()
  const [identityClient, setClient] = useState()
  const [loading, setLoading] = useState(true)
  const [popupOpen, setPopupOpen] = useState(false)

  useEffect(() => {
    const initAuth0 = async () => {
      const identityClient = await getIdentityClientInstance({
        domain,
        clientId,
        redirectUrl,
      })
      setClient(identityClient)

      if (
        window.location.search.includes('code=') &&
        window.location.search.includes('state=')
      ) {
        const { appState } = await identityClient.handleRedirectCallback()
        onRedirectCallback(appState)
      }

      const isAuthenticated = await identityClient.isAuthenticated()

      setIsAuthenticated(isAuthenticated)

      if (isAuthenticated) {
        const user = await identityClient.getUser()
        setUser(user)

        const account = await AuthService.fetchCurrentAccount()
        setOrganization({ logo: account.logo, name: account.company })
      }

      setLoading(false)
    }
    initAuth0()
    // eslint-disable-next-line
  }, [])

  const loginWithPopup = async (params = {}) => {
    setPopupOpen(true)
    try {
      await identityClient.loginWithPopup(params)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setPopupOpen(false)
    }
    const user = await identityClient.getUser()
    setUser(user)
    setIsAuthenticated(true)
  }

  const handleRedirectCallback = async () => {
    setLoading(true)
    await identityClient.handleRedirectCallback()
    const user = await identityClient.getUser()
    setLoading(false)
    setIsAuthenticated(true)
    setUser(user)
  }

  return (
    <IdentityContext.Provider
      value={{
        isAuthenticated,
        user,
        setUser,
        role: getRole(user),
        loading,
        organization,
        popupOpen,
        loginWithPopup,
        handleRedirectCallback,
        getIdTokenClaims: (...p) => identityClient.getIdTokenClaims(...p),
        loginWithRedirect: (...p) => identityClient.loginWithRedirect(...p),
        getTokenSilently: (...p) => identityClient.getTokenSilently(...p),
        getTokenWithPopup: (...p) => identityClient.getTokenWithPopup(...p),
        logout: (p = {}) =>
          identityClient.logout({
            returnTo: redirectUrl,
            ...p,
          }),
      }}
    >
      {children}
    </IdentityContext.Provider>
  )
}
